<template>
  <failed-captures-list
    @loadData="loadData($event)"
    :listItems="failedCaptures"
    :listLoading="listLoading"
    :selectedLanguage="selectedLanguage"
    :reportGenerating="reportGenerating"
    :totalItems="totalCount"
  ></failed-captures-list>
</template>

<script>
import { failedCaptures } from '@/mixins/failedCaptures.mixins';
import FailedCapturesList from '@/components/FailedCapturesList.vue';
import { languageMethods, languageComputed } from '../../mixins/language.mixins';
import { csvReport } from '../../mixins/csvReport.mixins';
import { download } from '../../mixins/download.mixins';

export default {
  name: 'failed-captures-view',
  components: { FailedCapturesList },
  mixins: [
    csvReport,
    download,
    failedCaptures,
    languageMethods,
    languageComputed,
  ],
  computed: {
    totalCount() {
      return this.listInfo.totalCount;
    },
  },
  methods: {
    async loadData({ sort, page, maxPerPage, startDate, endDate, dateType, dynamicSearch }) {
      this.listConfig = {
        page,
        maxPerPage,
        sort,
        startDate,
        endDate,
        dateType,
        dynamicSearch,
      };
      await this.listFailedCaptures();
    },
  },
};
</script>
